import { render } from "./how_are_dashboard_metrics_calculated.vue?vue&type=template&id=2eb32910&scoped=true"
import script from "./how_are_dashboard_metrics_calculated.vue?vue&type=script&lang=js"
export * from "./how_are_dashboard_metrics_calculated.vue?vue&type=script&lang=js"

import "./how_are_dashboard_metrics_calculated.vue?vue&type=style&index=0&id=2eb32910&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb32910"]])

export default __exports__